import { render, staticRenderFns } from "./RezultatiSinglePanel.vue?vue&type=template&id=362bd958&scoped=true&"
import script from "./RezultatiSinglePanel.vue?vue&type=script&lang=js&"
export * from "./RezultatiSinglePanel.vue?vue&type=script&lang=js&"
import style0 from "./RezultatiSinglePanel.vue?vue&type=style&index=0&id=362bd958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362bd958",
  null
  
)

export default component.exports